import { forwardRef } from 'react';
import { Link as RouterLink, LinkProps, useLocation } from 'react-router-dom';
import { getLangFromPath, localizePath } from '../i18n/langs';

/** Añade la barra final a rutas internas ("/cie" -> "/cie/"): es la URL real que sirve el servidor, así los enlaces no pasan por una redirección 301. */
export const withSlash = (p: string): string => {
  const m = p.match(/^([^?#]*)(.*)$/);
  const path = m ? m[1] : p;
  const rest = m ? m[2] : '';
  if (!path.startsWith('/') || path.endsWith('/') || /\.[a-z0-9]+$/i.test(path)) return p;
  return path + '/' + rest;
};

/** Igual que el Link de react-router, pero añade el prefijo del idioma actual (/ca, /en, /fr). */
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ to, ...rest }, ref) => {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const target = typeof to === 'string' ? withSlash(localizePath(to, lang)) : to;
  return <RouterLink ref={ref} to={target} {...rest} />;
});

Link.displayName = 'LocalizedLink';

export const useLocalizedPath = () => {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  return (path: string) => withSlash(localizePath(path, lang));
};

export default Link;
